import { updateField, getField } from 'vuex-map-fields'
import api from '../api'
import countries from '../../json/countries.json'

const state = {

	notifications: {
		data: [],
		current_page: 0,
		last_page: 0,
		total: 0
	},
	notificationLoading: false,

	notification: {
		title: '',
		description: '',
		date: '',
		time: '',
		gender: [],
		ageFrom: 0,
		ageTo: 0,
		users: [],
		country: []
	},

	oldNotification: {
		title: '',
		description: '',
		date: '',
		time: '',
		gender: [],
		ageFrom: 0,
		ageTo: 0,
		users: [],
		country: []
	},

	buttonLoading: false,

	userList: {
		current_page: 0,
		last_page: 0,
		data: []
	},
	userListLoading: false,

	userViewList: {
		data: []
	},
	userViewLoading: false,

	userFilter: {
		country: false,
		age: false,
		gender: false,
		keyword: ''
	},

	countryKeyword: '',
    countryList: countries,
}

const mutations = {
	updateField
}

const actions = {
	async getList ({ state }, payload) {
		state.notificationLoading = true

		const { data, status } = await api('get', `/cms/notification/list${payload}`)

		if (status) {
			state.notifications = data.data
			state.notificationLoading = false
			return
		}

		state.notificationLoading = false
	},

	async create ({ state, dispatch, commit}, payload) {
		state.buttonLoading = true

		const { status } = await api('post', '/cms/notification/create', payload.form)

		if (status) {
			await dispatch('clearData')

            await commit('modal/toggleNotification', {
                notificationName: 'notification-banner',
                notificationType: 'success',
                notificationDesc: 'Notification is successfully created.',
            }, { root: true })

			state.buttonLoading = false
			return
		}

        await commit('modal/toggleNotification', {
            notificationName: 'notification-banner',
            notificationType: 'failed',
            notificationDesc: 'Sorry, something went wrong.',
        }, { root: true })
		state.buttonLoading = false
	},

	async edit ({ state }, payload) {
		state.buttonLoading = true

		const { data, status } = await api('get', `/cms/notification/view?id=${payload}`)

		if (status) {
			const {
				title,
				description,
				age_from,
				age_to,
				gender,
				notification_date,
				users,
				country
			} = data.data
			const [ date, time ] = notification_date.split(' ')
			let countries = []
			country.forEach(country => {
				countries.push(state.countryList.filter(i => i.name === country)[0])
			})
			state.notification.title = title
			state.notification.description = description
			state.notification.gender = gender
			state.notification.ageFrom = age_from
			state.notification.ageTo = age_to
			state.notification.users = users
			state.notification.country = countries
			state.notification.date = new Date(date)
			state.notification.time = new Date(`${date} ${time}`)

			state.oldNotification.title = title
			state.oldNotification.description = description
			state.oldNotification.gender = gender
			state.oldNotification.ageFrom = age_from
			state.oldNotification.ageTo = age_to
			state.oldNotification.users = users
			state.oldNotification.country = countries
			state.oldNotification.date = new Date(date)
			state.oldNotification.time = new Date(`${date} ${time}`)

			state.userFilter.age = !!(age_from && age_to)
			state.userFilter.country = !!country.length
			state.userFilter.gender = !!gender.length

			state.buttonLoading = false
			return
		}

		state.buttonLoading = false
	},

	async update ({ state, dispatch, commit }, payload) {
		state.buttonLoading = true

		const { status } = await api('post', '/cms/notification/update', payload.form)

		if (status) {
			await dispatch('clearData')

            await commit('modal/toggleNotification', {
                notificationName: 'notification-banner',
                notificationType: 'success',
                notificationDesc: 'Notification is successfully updated.',
            }, { root: true })

			state.buttonLoading = false
			return true
		}

        await commit('modal/toggleNotification', {
            notificationName: 'notification-banner',
            notificationType: 'failed',
            notificationDesc: 'Sorry, something went wrong.',
        }, { root: true })
		state.buttonLoading = false
        return false
	},

	async delete ({ state, dispatch, commit }, payload) {
		state.buttonLoading = true

		const { data, status } = await api('post', `/cms/notification/delete`, payload.form)

		if (status) {
            await commit('modal/toggleNotification', {
                notificationName: 'notification-banner',
                notificationType: 'success',
                notificationDesc: 'Notification is successfully deleted.',
            }, { root: true })

			// if no data on return call getList of previous page
			if (data.data.data.length === 0 && data.data.current_page > 1) {
				await payload.callback(data.data.current_page - 1)
				state.buttonLoading = false
				return true
			}

			state.notifications = data.data
			state.buttonLoading = false
			return true
		}
        
        await commit('modal/toggleNotification', {
            notificationName: 'notification-banner',
            notificationType: 'failed',
            notificationDesc: 'Failed to delete notification.',
        }, { root: true })
		dispatch('closeModal', null, { root: true })
		state.buttonLoading = false
		return false
	},

	async getUserList ({ state }, payload) {
		state.userListLoading = true

		const { data, status } = await api('get', `/cms/notification/user-list${payload}`)

		if (status) {
			state.userList.data = [...state.userList.data, ...data.data.data]
			state.userList.current_page = data.data.current_page
			state.userList.last_page = data.data.last_page
			state.userListLoading = false
			return
		}

		state.userListLoading = false
	},

	async viewUser ({ state }, payload) {
		state.userViewLoading = true

		const { data, status } = await api('get', `/cms/notification/view-user${payload}`)

		if (status) {
			state.userViewList = data.data
			state.userViewLoading = false
			return
		}

		state.userViewLoading = false
	},

	hasValues ({ state }) {
		const {
			title,
			description,
			date,
			time,
			gender,
			ageFrom,
			ageTo,
			users,
			country
		} = state.notification

		return ageTo ||
				ageFrom ||
				date ||
				time ||
				gender.length ||
				users.length ||
				description.trim() !== '' ||
				title.trim() !== '' ||
				country.length
	},

	async hasChanges ({ state, dispatch }) {
		const {
			title,
			description,
			date,
			time,
			gender,
			ageFrom,
			ageTo,
			users,
			country
		} = state.notification

		const hasValues = await dispatch('hasValues')

		if (!hasValues) return false

		const oldGender = state.oldNotification.gender
		const oldUsers = state.oldNotification.users.map(item => item.id)
		const oldCountry = state.oldNotification.country
		const oldDate = new Date(state.oldNotification.date).valueOf()
		const newDate = new Date(date).valueOf()
		const oldTime = new Date(state.oldNotification.time).valueOf()
		const newTime = new Date(time).valueOf()

		console.log(newTime)
		console.log(oldTime)

		return ageTo !== state.oldNotification.ageTo ||
			ageFrom !== state.oldNotification.ageFrom ||
			newDate !== oldDate ||
			newTime !== oldTime ||
			gender.some(item => !oldGender.includes(item)) ||
			users.some(item => !oldUsers.includes(item.id)) ||
			country.some(item => !oldCountry.includes(item)) ||
			description !== state.oldNotification.description ||
			title !== state.oldNotification.title
	},

	async clearData ({ state }) {
		state.notification = {
			title: '',
			description: '',
			date: '',
			time: '',
			gender: [],
			ageFrom: '',
			ageTo: 0,
			users: [],
			country: []
		}

		state.oldNotification = {
			title: '',
			description: '',
			date: '',
			time: '',
			gender: [],
			ageFrom: '',
			ageTo: 0,
			users: [],
			country: []
		}

		state.userFilter = {
			country: false,
			age: false,
			gender: false,
			keyword: ''
		}
		state.countryKeyword = ''

		// state.userList = {
		// 	current_page: 0,
		// 	last_page: 0,
		// 	data: []
		// }
	}
}

const getters = {
	getField
}

export default {
	state,
	namespaced: true,
	mutations,
	actions,
	getters
}
